import $ from 'jquery';
import React from 'react';
import FlightsTable from '../../components/flightsTable';
import AdsSlider from '../../components/adsSlider'
import Header from '../../components/header';
import BigImageSlider from '../../components/bigImageSlider';
import Footer from '../../components/footer';
import Menu from '../../components/menu';
import { Link } from 'react-router-dom';
import AlertBar from '../../components/alertBar';
import config from '../../config';
import request from 'superagent';
import './index.css';

let country = '';
let submitted = false;

if (localStorage && localStorage.getItem('_survey_new-countries_submitted') === 'true') {
  submitted = true;
}

export default (props, routerProps) => ({
  componentDidMount() {
    if (routerProps && routerProps.location && routerProps.location.hash === '#flights-table') {
      window.scrollTo(0, $("#flights-table").offset().top);
    }
  },

  updateCountry(event) {
    country = event.target.value
  },

  submitSurveyAnswer() {
    request
    .get(`${config.serverUrl}/survey/submitAnswer?survey=new-countries&answer=${country}`)
    .end((err, resp) => {
      submitted = true;

      localStorage.setItem('_survey_new-countries_submitted', 'true');

      window.location = '.';
    });
  },

  renderNewDestinations() {
    const renderedCountries = config.countries.map(country => (
      <option value={country.name}>{country.name}</option>
    ));

    let newDestinations = null;

    if (submitted === true) {
      newDestinations = (
        <div>
          <h6>Multumim pentru participare!</h6>
        </div>
      );
    } else {
      newDestinations = (
        <div>
          <div className="u-m-b-15">
            <h6>Care din următoarele destinații vă interesează?</h6>
          </div>

          <select className="form-control u-m-b-15" onChange={this.updateCountry.bind(this)}>
            {renderedCountries}
          </select>

          <button type="button" className="btn btn-success" onClick={this.submitSurveyAnswer.bind(this)}>
            Trimite
          </button>
        </div>
      );
    }

    return newDestinations;
  },

  render() {
    const newDestinations = submitted ? <h6>Mulțumim!</h6> : this.renderNewDestinations();

    return (
      <div className="viewsHomepage">
        <Header {...props} />
        <AlertBar showLink={true} />
        <BigImageSlider {...props} />

        <div className="padded-top-content">
          <div className="col-md-8 offset-md-2">
            <Menu menuItems={props.menuItems} />
          </div>

          <div className="col-md-8 offset-md-2 m-t-big">
            <div className="row">
              <div className="col-md-6 u-p-or-15">
                <AdsSlider position="homepage-top-left" />
              </div>
              <div className="col-md-6 u-p-ol-15">
                <AdsSlider position="homepage-top-right" />
              </div>
            </div>
          </div>

          <div className="col-md-8 offset-md-2 m-t-double-big m-big-padding">
            <FlightsTable />
          </div>

          <div className="col-md-8 offset-md-2 m-t-big bg-theme1 new-destinations item-with-box-shadow">
            {newDestinations}
          </div>

          <div className="col-md-8 offset-md-2 m-t-big">
            <div className="row">
              <div className="col-md-6 u-p-or-15">
                <AdsSlider position="homepage-bottom" />
              </div>
              <div className="col-md-6 u-p-ol-15">
                <div className="iasi">
                  <div className="row u-flex-center iasi__image" style={{backgroundImage: `url("${props.iasiImage}")`}}>
                    <Link to='/iasi'>
                      <div className="text">
                        <h1>Cum să ajungi în Iași</h1>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <Footer {...props} />
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/homepage/index.js